import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classnames from 'classnames';

import { configPlayer, mapAssetType } from './video-utils';
import { DEFAULT_CTA } from './metadata';
import closeIcon from './media/close.svg';
import passportIcon from './media/passport.svg';
import styles from './video-player.scss';

class VideoPlayer extends Component {
    static propTypes = {
        componentId: PropTypes.string.isRequired,
        handleCTAChange: PropTypes.func.isRequired,
        CallToAction: PropTypes.func.isRequired,
        showVideo: PropTypes.bool.isRequired,
        playerClass: PropTypes.string,
        videoClose: PropTypes.func.isRequired,
        cta: PropTypes.shape({
            link: PropTypes.object.isRequired,
            text: PropTypes.string.isRequired,
            textPlaceholder: PropTypes.string.isRequired
        }),
        settings: PropTypes.shape({
            displayCTA: PropTypes.bool.isRequired,
            player: PropTypes.shape({
                topbar: PropTypes.bool.isRequired,
                autoplay: PropTypes.bool.isRequired
            }).isRequired
        }),
        callsign: PropTypes.string,
        currentSite: PropTypes.object.isRequired,
        currentVideo: PropTypes.object,
        isSomethingDragging: PropTypes.bool.isRequired,
        reference: PropTypes.object
    };

    static defaultProps = {
        cta: DEFAULT_CTA,
        playerClass: '',
        isSomethingDragging: false
    };

    getCallsign = () => {
        const { currentSite: { siteType, station } = {}, callsign } = this.props;
        if (callsign) {
            return callsign;
        }
        if (siteType === 'station' && station && station.callSign) {
            return station.callSign;
        }
        return '';
    };

    render() {
        const {
            settings: { player, displayCTA },
            currentVideo,
            componentId,
            handleCTAChange,
            cta,
            CallToAction,
            showVideo,
            playerClass,
            videoClose,
            isSomethingDragging,
            reference
        } = this.props;

        if (playerClass && !showVideo) {
            return null;
        }
        if (!currentVideo) {
            return null;
        }

        const {
            showTitle,
            videoTitle,
            duration,
            date,
            rating,
            type,
            longDescription,
            id,
            isPassportVideo
        } = currentVideo;
        const videoMeta = [mapAssetType(type), duration, date, rating]
            .filter((item) => !!item)
            .join(' | ');
        const callsign = this.getCallsign();
        const config = callsign ? { ...player, callsign } : player;

        return (
            <div
                ref={reference}
                className={classnames({
                    [styles.videoPlayer]: true,
                    'video-player': true,
                    [playerClass]: true
                })}>
                {playerClass && <img className="close" src={closeIcon} onClick={videoClose} />}
                <div className="left-side">
                    <div
                        className={classnames({
                            'rsponsive-player-wrapper': true,
                            'top-bar': player.topbar,
                            'shape-placeholder-fill': true
                        })}>
                        {currentVideo.playerIframe && !isSomethingDragging && (
                            <div
                                className="player"
                                dangerouslySetInnerHTML={{
                                    __html: configPlayer(currentVideo.playerIframe, config)
                                }}
                            />
                        )}
                    </div>
                </div>
                <div className="right-side">
                    <h4 className="text-placeholder show-title">{showTitle}</h4>
                    <h3 className="text-placeholder video-title">{videoTitle}</h3>
                    <div className="text-placeholder video-meta">
                        {isPassportVideo && <img className="passport-icon" src={passportIcon} />}
                        {videoMeta}
                    </div>
                    <p className="text-placeholder-long double description">{longDescription}</p>
                    {displayCTA && (
                        <CallToAction
                            {...this.props}
                            componentId={componentId}
                            handleCTAChange={handleCTAChange}
                            videoId={id}
                            cta={cta}
                        />
                    )}
                </div>
            </div>
        );
    }
}

export default VideoPlayer;
